import { CACHE_HEADER_ENABLED } from "@sinch/cache-helpers";
import { API_BASE_URL } from "../../config/legacy-frozen-config";
import type { ShellUser } from "../types";
import { UserMeZod, type UserMePartial } from "./engage.types";

export const engageFetchUserURL = `${API_BASE_URL}/api/v16/agent/me`;

export const getEngageUser = (token: string) =>
  window
    .fetch(engageFetchUserURL, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        [CACHE_HEADER_ENABLED]: "true",
      },
    })
    .then((r) => r.json())
    .then((data) => {
      const parsed = UserMeZod.safeParse(data);
      if (parsed.success) return parsed.data;
      console.error("Invalid response from /agent/me", parsed.error);
      return data as UserMePartial;
    })
    .then(toShellUser);

export const toShellUser = (data: unknown): ShellUser => {
  const parsed = UserMeZod.safeParse(data);
  if (!parsed.success)
    console.error("Invalid response from /agent/me", parsed.error);

  const engageUser = parsed.success ? parsed.data : (data as UserMePartial);

  return {
    id: engageUser.id?.toString(),
    name: engageUser.name,
    email: engageUser.email,
    rights: engageUser.rights,
    language: engageUser.language,
    profile_image: engageUser.profile_image,
    roles: engageUser.roles,
    status: engageUser.status,
    activeProject: engageUser.activeProject,
    settings: {
      ...engageUser.settings,
      // Legacy stuff
      activeProject: engageUser.activeProject,
      activeChannel: engageUser.activeChannel,
      channels: engageUser.channels,
    },
  };
};
